'use client';

import { useEffect } from 'react';
import type { Experiment } from '@/types/aggregation/home';
import { useStore } from '@/store/store';

export const useSearchRedesign = (experiments: Experiment): void => {
    useEffect(() => {
        useStore.getState().search.setIsSearchRedesignVariant(experiments);
    }, [experiments]);
};
